import '../styles/Natural-slider.css';

const NaturalSlider = () => {
    return; 
};

export default NaturalSlider; 